import {
    PRICE_POLICIES_SET_DATA_FILTER_SELECTED
  } from '../constants'
  
  export function reducer(state, action) {
    if (action.type === PRICE_POLICIES_SET_DATA_FILTER_SELECTED ) {
        return {
          ...state,
          dataFilterSelected: {...action.data.dataFilterSelected}
        }
    } else{
        return state
    }
}